import * as React from "react"
import { Box } from "@mui/material"
import { formatPriceSymbol } from "@ui-seeker/utils"

import { NotAllowedBlock } from "@components"


export default function myPriceColumn(name, label) {
	return [{
		name: 'status', label: 'Status',
		options: { display: 'excluded' }
	}, {
		name: name, label: label,
		options: {
			filter: false,
			customBodyRowRender: (value, row) => {
				return <Box sx={{ textAlign: 'center' }}>
					{!!value && formatPriceSymbol(value, row.currency)}
					{!value && <NotAllowedBlock />}
				</Box>
			}
		}
	}]
}